import Box from 'components/Containers/Box';
import CenterAlignBox from 'components/Containers/CenterAlignBox';
import { Row } from 'components/Containers/Row/Row';
import RowBox from 'components/Containers/RowBox';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import SpreadBox from 'components/Containers/SpreadBox';
import Label from 'components/form/Label/Label';
import { Image } from 'components/Image/Image';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { KYC_HARD_FAIL } from 'types/morph.pagePosition.constants';
import { BANKING_VERTICAL } from 'types/mrph.vertical.constants';
import './KYCHardFail.scss';

const KYCHardFail = props => {
  const atr = getViewModuleTrackingAttributes({
    pagePosition: KYC_HARD_FAIL,
    vertical: BANKING_VERTICAL,
    modulePosition: props.modulePosition,
  });
  const seenPixel = useSeenModulePixel(atr);
  return (
    <>
      <SectionContainer>
        {seenPixel}
        <Row>
          <SpreadBox alignItemsStart className="KYCHardFail">
            <Box widthClassName="format50 m-format100">
              <Label type="H3 mH5" className="padB24">
                Verify your information
              </Label>
              <Label type="Body-1" className="padB16">
                Please email{' '}
                <span className="link-style bold">
                  sesamecash@creditsesame.com
                </span>{' '}
                to complete your account registration.
              </Label>

              <CenterAlignBox className="d-hide padT40">
                <Image
                  className="bgImageW263 bgImageH240"
                  imgClass="kycHardFailHeroimg"
                />
              </CenterAlignBox>
            </Box>
            <RowBox className="t-hide" justifyEnd widthClassName="format50">
              <Image
                className="bgImageW263 bgImageH240"
                imgClass="kycHardFailHeroimg"
              />
            </RowBox>
          </SpreadBox>
        </Row>
      </SectionContainer>
    </>
  );
};
export default KYCHardFail;
